var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClothingAccessories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      height: 512,
      width: 512
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-bg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0,
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h512v512H0z",
    fill: "#417505",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("g", {
    className: "",
    transform: "translate(0,0)",
    style: {}
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M256 126.97c-86.364 0-225.564 39.103-234.6 109.96-9.828 90.817 77.986 124.365 144.875 128.814v-78.592c-52.133 0-70.272-22.63-66.675-50.222 7.275-55.81 100.12-63.614 156.4-63.614s149.125 7.805 156.4 63.614c3.597 27.59-14.542 50.222-66.675 50.222v78.592c66.89-4.45 154.703-37.997 144.875-128.814-5.604-78.746-148.236-109.96-234.6-109.96zm71.656 152.257l-143.312.02V384.87l143.312.157V279.226zm-17.642 21.507v23.606h-82.29v19.592h82.29v21.523h-104.12V300.8h32.33l71.79-.066z",
    fill: "#a36528",
    fillOpacity: 1,
    clipPath: "url(#icon-bg)",
    transform: "translate(512, 512) scale(-1, -1) rotate(-180, 256, 256) skewX(0) skewY(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClothingAccessories);
export default __webpack_public_path__ + "static/media/clothing-accessories.6449a4463acc72cbf056b27c8d5e5de8.svg";
export { ForwardRef as ReactComponent };